import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import studentsReducer from './slices/studentsSlice';
import classesReducer from './slices/classesSlice';
import staffReducer from './slices/staffSlice';
import busesReducer from './slices/busesSlice';
import financeReducer from './slices/financeSlice';
import employeeTypesSlice from './slices/employeeTypesSlice';
import authorizedPayersSlice from './slices/authorizedPayersSlice';
import recipientReducer from './slices/recipientSlice';
import schoolFeesReducer from './slices/schoolFeesSlice';
import accountReducer from './slices/accountSlice';
import logsReducer from './slices/logsSlice';
import schoolYearsReducer from './slices/schoolYearsSlice';
import storeReducer from './slices/storeSlice';
import subjectsReducer from './slices/subjectsSlice';
import scheduleSlice from './slices/scheduleSlice';
import attendanceReducer from './slices/attendanceSlice';
import substituteReducer from './slices/substituteSlice';
import usersReducer from './slices/usersSlice';
import yearTransitionReducer from './slices/yearTransitionSlice';
import voucherNumberSettingsReducer from './slices/voucherNumberSettingsSlice';
import storePurchasesReducer from './slices/storePurchasesSlice';
import miscellaneousReducer from './slices/miscellaneousSlice';
import reportsReducer from './slices/reportsSlice';
import academicsReducer from './slices/academicsSlice';
import libraryReducer from './slices/librarySlice';
import healthReducer from './slices/healthSlice';
import eventsReducer from './slices/eventsSlice';
import feesManagementReducer from './slices/feesManagementSlice';
import bankDataReducer from './slices/bankDataSlice';
import superAdminReducer from './slices/superAdminSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    students: studentsReducer,
    classes: classesReducer,
    staff: staffReducer,
    buses: busesReducer,
    finance: financeReducer,
    employeeTypes: employeeTypesSlice,
    authorizedPayers: authorizedPayersSlice,
    recipients: recipientReducer,
    schoolFees: schoolFeesReducer,
    account: accountReducer,
    logs: logsReducer,
    schoolYears: schoolYearsReducer,
    store: storeReducer,
    subjects: subjectsReducer,
    schedule: scheduleSlice,
    attendance: attendanceReducer,
    substitute: substituteReducer,
    users: usersReducer,
    yearTransition: yearTransitionReducer,
    voucherNumberSettings: voucherNumberSettingsReducer,
    storePurchases: storePurchasesReducer,
    miscellaneous: miscellaneousReducer,
    reports: reportsReducer,
    academics: academicsReducer,
    library: libraryReducer,
    health: healthReducer,
    events: eventsReducer,
    feesManagement: feesManagementReducer,
    bankData: bankDataReducer,
    superAdmin: superAdminReducer,
  },
});
